<template>
  <div>
    <Icon
      :class="$style.warningIcon"
      icon="error"
      inline
    />
    You have an outstanding balance on your account.
    <ButtonLink
      text="Update"
      @click="openPaymentsModal"
    />
    your credit card on file to dismiss this notification or email
    <Link
      :href="mailToBillingLink"
      target="_blank"
      text="billing@jumpcloud.com"
    />
    to use another method of payment.
    <Link
      :href="$options.billingLink"
      target="_blank"
      text="Learn more"
    />.
  </div>
</template>
<script>
import {
  ButtonLink,
  Icon,
  Link,
} from '@jumpcloud/ui-components';
import { paymentSources } from 'client/GrowthEngineering/utilities/GrowthConstants';
import PastDueEmailbillingMixin from 'client/Payments/components/UserLockNoPaymentModal/PastDueEmailbillingMixin';
import SubmitPaymentService from 'client/Payments/SubmitPaymentService';

export default {
  name: 'PastDueAccountFirstWarningBannerSlot',

  components: {
    ButtonLink,
    Icon,
    Link,
  },

  mixins: [PastDueEmailbillingMixin],

  methods: {
    openPaymentsModal() {
      SubmitPaymentService.openPaymentsModal(paymentSources.pastDueAccountBanner);
    },
  },
};
</script>

<style module>
.warningIcon {
  color: var(--jc-color-error-on-surface);
}
</style>
